import { Location } from "history"
import React, { useEffect, useState } from "react"
import { Prompt } from "react-router-dom"
import { Confirm } from "../Modal/Confirm"

interface Props {
    navigate: (path: string) => void
    shouldBlockNavigation: (location: Location) => boolean
    onBlock?: () => void
    onUnblock?: () => void
    onNavigate?: () => void
}

export const NavPrompt = ({
    navigate,
    shouldBlockNavigation,
    onBlock,
    onUnblock,
    onNavigate
}: Props) => {
    const [modalVisible, setModalVisible] = useState(false)

    const [lastLocation, setLastLocation] = useState<Location | null>(null)

    const [confirmedNavigation, setConfirmedNavigation] = useState(false)

    const closeModal = () => {
        onUnblock?.()
        setModalVisible(false)
    }

    const handleBlockedNavigation = (nextLocation: Location): boolean => {
        if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
            onBlock?.()
            setModalVisible(true)
            setLastLocation(nextLocation)
            return false
        }
        return true
    }

    const handleConfirmNavigationClick = () => {
        onUnblock?.()
        onNavigate?.()
        setModalVisible(false)
        setConfirmedNavigation(true)
    }

    useEffect(() => {
        if (confirmedNavigation && lastLocation) {
            // reset navigation in case the page is does not navigate away (e.g. changing mode on AddData)
            setConfirmedNavigation(false)
            // Navigate to the previous blocked location with your navigate function
            navigate(lastLocation.pathname + lastLocation.search.toString())
        }
    }, [confirmedNavigation, lastLocation, navigate])

    return (
        <>
            <Prompt message={handleBlockedNavigation} />
            {modalVisible && (
                <Confirm
                    onClose={closeModal}
                    title="Discard changes?"
                    yesLabel="Discard"
                    noLabel="Keep editing"
                    onClickYes={handleConfirmNavigationClick}
                    onClickNo={closeModal}
                />
            )}
        </>
    )
}
